"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Image_1 = __importDefault(require("stremio/components/Image"));
var MetaLinks_1 = __importDefault(require("stremio/components/MetaPreview/MetaLinks"));
var EPG_1 = require("stremio/common/EPG");
var Hero_less_1 = __importDefault(require("./Hero.less"));
var renderChannelIcon = function () { return react_1.default.createElement(react_2.default, { name: 'tv' }); };
var Hero = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var channel = _a.channel, addonName = _a.addonName, description = _a.description, hasSchedule = _a.hasSchedule, selected = _a.selected, now = _a.now, children = _a.children;
    var _l = (0, react_i18next_1.useTranslation)(), t = _l.t, i18n = _l.i18n;
    var informationRef = (0, react_1.useRef)(null);
    var selectedStartTime = selected === null || selected === void 0 ? void 0 : selected.startTime.getTime();
    var progress = selected ? (0, EPG_1.getEpgProgress)(selected, now) : null;
    var status = progress !== null || selected === null ? 'live' : selected.endTime.getTime() <= now ? 'aired' : 'upcoming';
    var dateLabel = selected === null || selected === void 0 ? void 0 : selected.startTime.toLocaleDateString(i18n.language, { weekday: 'long', month: 'short', day: 'numeric' });
    var genres = ((_b = selected === null || selected === void 0 ? void 0 : selected.genres) === null || _b === void 0 ? void 0 : _b.length) ?
        selected.genres
        :
            (_d = (_c = selected === null || selected === void 0 ? void 0 : selected.links) === null || _c === void 0 ? void 0 : _c.filter(function (_a) {
                var category = _a.category;
                return category === 'Genres';
            }).map(function (_a) {
                var name = _a.name;
                return name;
            })) !== null && _d !== void 0 ? _d : [];
    var ratings = (_f = (_e = selected === null || selected === void 0 ? void 0 : selected.ratings) === null || _e === void 0 ? void 0 : _e.filter(function (rating) { return rating.value.trim(); })) !== null && _f !== void 0 ? _f : [];
    var fallbackDescription = hasSchedule ? null : t('LIVE_TV_NO_SCHEDULE', { defaultValue: 'Programme information is unavailable for this channel.' });
    (0, react_1.useLayoutEffect)(function () {
        if (informationRef.current)
            informationRef.current.scrollTop = 0;
    }, [selected === null || selected === void 0 ? void 0 : selected.id, selectedStartTime]);
    return (react_1.default.createElement("div", { className: Hero_less_1.default['hero'], "aria-label": (_g = selected === null || selected === void 0 ? void 0 : selected.title) !== null && _g !== void 0 ? _g : channel.name },
        react_1.default.createElement("div", { className: Hero_less_1.default['hero-content'] },
            react_1.default.createElement("div", { className: Hero_less_1.default['channel-header'] },
                react_1.default.createElement("div", { className: Hero_less_1.default['channel-logo'] }, channel.logo ?
                    react_1.default.createElement(Image_1.default, { src: channel.logo, alt: '', renderFallback: renderChannelIcon })
                    :
                        react_1.default.createElement(react_2.default, { name: 'tv' })),
                react_1.default.createElement("div", { className: Hero_less_1.default['channel-identity'] },
                    react_1.default.createElement("div", { className: Hero_less_1.default['channel-name'] }, channel.name),
                    react_1.default.createElement("div", { className: Hero_less_1.default['addon-name'] }, addonName))),
            react_1.default.createElement("div", { ref: informationRef, className: Hero_less_1.default['current-information'] },
                react_1.default.createElement("div", { "aria-live": 'polite', "aria-atomic": 'true' },
                    react_1.default.createElement("div", { className: Hero_less_1.default['current-time'] },
                        status === 'live' ?
                            react_1.default.createElement("div", { className: Hero_less_1.default['live-badge'] },
                                react_1.default.createElement("div", { className: Hero_less_1.default['live-dot'] }),
                                t('PLAYER_LIVE'))
                            :
                                react_1.default.createElement("div", { className: Hero_less_1.default['program-status'] }, status === 'aired' ? t('AIRED') : t('UPCOMING')),
                        dateLabel ?
                            react_1.default.createElement("div", null, dateLabel)
                            :
                                null,
                        selected !== null ?
                            react_1.default.createElement("div", null, (0, EPG_1.formatEpgTimeRange)(selected.startTime, selected.endTime, i18n.language))
                            :
                                null,
                        (selected === null || selected === void 0 ? void 0 : selected.runtime) ?
                            react_1.default.createElement("div", null, selected.runtime)
                            :
                                null,
                        ratings.map(function (rating, index) { return (react_1.default.createElement("div", { key: "".concat(rating.system, ":").concat(rating.value, ":").concat(index), className: Hero_less_1.default['content-rating'], title: rating.system ? "".concat(rating.system, ": ").concat(rating.value) : rating.value }, rating.icon ?
                            react_1.default.createElement(Image_1.default, { src: rating.icon, alt: rating.value, renderFallback: function () { return rating.value; } })
                            :
                                rating.value)); })),
                    react_1.default.createElement("div", { className: Hero_less_1.default['title'] }, (_h = selected === null || selected === void 0 ? void 0 : selected.title) !== null && _h !== void 0 ? _h : t('LIVE_TV_NO_PROGRAM', { defaultValue: 'No programme information right now' }))),
                react_1.default.createElement("div", { className: Hero_less_1.default['description'] }, (_k = (_j = selected === null || selected === void 0 ? void 0 : selected.overview) !== null && _j !== void 0 ? _j : description) !== null && _k !== void 0 ? _k : fallbackDescription),
                genres.length > 0 ?
                    react_1.default.createElement(MetaLinks_1.default, { className: Hero_less_1.default['genres'], label: 'Genres', links: genres.map(function (genre) { return ({ label: genre }); }) })
                    :
                        null,
                progress !== null && selected !== null ?
                    react_1.default.createElement("div", { className: Hero_less_1.default['broadcast-progress'] },
                        react_1.default.createElement("div", { className: Hero_less_1.default['progress-track'] },
                            react_1.default.createElement("div", { style: { width: "".concat(progress, "%") } })),
                        react_1.default.createElement("div", null, t('CONTINUE_WATCHING_TIME_LEFT', { minutes: Math.ceil((selected.endTime.getTime() - now) / 60000) })))
                    :
                        null),
            children)));
};
exports.default = Hero;
